export default {
  nameProvider: 'ชื่อผู้ให้บริการ'
};
